import { Heading, IconButton, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = () => {
    navigate('Consortium');
  };

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <IconButton
            testId="icon"
            icon="ArrowLeft"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            onPress={handleGoBack}
          />
          <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Consórcio
          </Text>
        </HStack>
      </HStack>
    );
  }

  return (
    <Heading testId="qa" size="h2">
      Recomendação enviada
    </Heading>
  );
};
